module.exports = __webpack_public_path__ + "img/Kc-What is your vision.2faaf193.png";